var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTranslationNeg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EDEDED;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_09---Translation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_17_",
    className: "st0",
    d: "M307.2,190.8c15.7-67.7-15.3-137.5-76.1-171.2S94.7-3.5,45.6,45.6s-59.7,124.8-26,185.6 s103.6,91.8,171.2,76.1C207.6,251.3,251.3,207.6,307.2,190.8L307.2,190.8z M214.1,228.5c-1,0.4-2.1,0.6-3.2,0.6 c-3.8,0-7.2-2.4-8.6-5.9L184,174.4h-55.8l-18.3,48.8c-1.8,4.7-7,7.1-11.7,5.4c-4.7-1.8-7.1-7-5.4-11.7l54.8-146 c1.3-3.6,4.7-5.9,8.6-5.9c3.8,0,7.2,2.4,8.6,5.9l54.8,146C221.2,221.5,218.8,226.8,214.1,228.5L214.1,228.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_16_",
    className: "st0",
    d: "M356.9,201.7c-85.7,0-155.1,69.5-155.1,155.1S271.2,512,356.9,512S512,442.5,512,356.9 C511.9,271.2,442.5,201.8,356.9,201.7z M429.9,311.2h-21.5c-11.2,25.4-26,48.9-44.1,69.9c14.4,16.7,31.9,30.4,51.4,40.6 c4.5,2.3,6.3,7.7,4.1,12.2c-2.3,4.5-7.7,6.3-12.2,4.1c-21.1-10.9-40-25.5-55.7-43.3c-16.1,16.8-34.4,31.4-54.5,43.2 c-4.4,2.4-10,0.7-12.4-3.7c-2.4-4.4-0.7-10,3.7-12.4c18.9-11.4,36.1-25.3,51.3-41.4c-7-9-13.3-18.6-18.7-28.7 c-2.3-4.5-0.5-10,4.1-12.3c4.5-2.3,10-0.5,12.3,4.1c4.3,8,9.3,15.7,14.8,23c14.3-16.9,26.4-35.5,36-55.4H283.9 c-5,0-9.1-4.1-9.1-9.1c0-5,4.1-9.1,9.1-9.1h63.9v-27.4c0-5,4.1-9.1,9.1-9.1s9.1,4.1,9.1,9.1V293h63.9c5,0,9.1,4.1,9.1,9.1 C439,307.2,434.9,311.2,429.9,311.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_26_",
    className: "st0",
    d: "M135.1,156.1h42.1L156.1,100L135.1,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25_",
    className: "st0",
    d: "M196.1,467.1c-1.2,3.7-4.7,6.3-8.7,6.3c-1,0-1.9-0.2-2.8-0.5 c-86.9-29.1-148-107.4-155.2-198.7c6.3,6.9,13.2,13.3,20.7,18.9c13.5,75.7,67.3,138,140.2,162.5 C195,457.2,197.6,462.3,196.1,467.1L196.1,467.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24_",
    className: "st0",
    d: "M483.6,238.8c-6.3-6.9-13.2-13.3-20.7-18.9c-13.5-75.7-67.3-138-140.2-162.5 c-3.2-0.9-5.7-3.5-6.4-6.8c-0.7-3.3,0.4-6.7,2.9-8.9c2.5-2.2,6-2.9,9.2-1.7C415.3,69.2,476.4,147.4,483.6,238.8L483.6,238.8z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslationNeg);
export default __webpack_public_path__ + "static/media/translation_neg.0f1f09b1ddf10030e9efb4f56b9f149e.svg";
export { ForwardRef as ReactComponent };